import { render, staticRenderFns } from "./ChangableMapComponent.vue?vue&type=template&id=22248834&scoped=true"
import script from "./ChangableMapComponent.vue?vue&type=script&lang=js"
export * from "./ChangableMapComponent.vue?vue&type=script&lang=js"
import style0 from "./ChangableMapComponent.vue?vue&type=style&index=0&id=22248834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22248834",
  null
  
)

export default component.exports